export default __webpack_public_path__ + "static/media/zak_working1.88a2ce7a.jpg";